import React from "react";

export default function StatBadge({ label, value }) {
  return (
    <div className="stat-badge">
      <span className="stat-value">{value ?? "—"}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}
